const getDefaultBackUrl = ({breadcrumb = [], adsListPathPattern}) => {
  const [{url: baseUrl} = {}, {url: makeUrl} = {}, {url: makeModelUrl} = {}, {url: makeModelProvinceUrl} = {}] =
    breadcrumb
  return makeModelProvinceUrl || makeModelUrl || makeUrl || baseUrl || adsListPathPattern
}

export default getDefaultBackUrl
